export function encode(str) {
      var s = ""
      if (str.length == 0) return ""
      s = str.replace(/&/g, "&amp;")
      s = s.replace(/</g, "&lt;")
      s = s.replace(/>/g, "&gt;")
      s = s.replace(/ /g, "&nbsp;")
      s = s.replace(/\'/g, "&#39;")
      s = s.replace(/\"/g, "&quot;")
      return s
}

export function filterDict(dict, query) {
      if (typeof dict == "undefined") {
            return []
      }
      if (query.Name != "") {
            let name = query.Name.toLowerCase()
            dict = dict.filter((d) => { return d.Name.toLowerCase().indexOf(name) > -1 })
      }
      if (query.ReportName != "") {
            let reportName = query.ReportName.toLowerCase()
            dict = dict.filter((d) => { return d.ReportName.toLowerCase().indexOf(reportName) > -1 })
      }
      return dict
}

export function showFile(fileName, blob) {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      var newBlob = new Blob([blob], { type: "application/pdf" })

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob)
            return
      }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob)
      var link = document.createElement("a")
      link.href = data
      link.download = fileName
      link.click()
      setTimeout(function () {
            window.URL.revokeObjectURL(data)
      }, 100)
}



// WEBPACK FOOTER //
// ./src/lib/lib.js